export default __webpack_public_path__ + "static/media/icon-coin-ftm.5dfb02cf.svg";